<template>
  <div
    :class="[className]"
    class="card card-contained"
  >
    <h4 class="card-header heading-xxs">
      <a
        :href="course.courseURL"
        target="_blank"
      >{{ course.courseTitle }}</a>
    </h4>
    <div class="card-text stack background-off-white">
      <h5 class="heading-xxs">
        Availability &amp; Campus:
      </h5>
      <table class="info-table info-table-availability">
        <thead>
					<tr>
						<th 
              class="info-table-location-heading"
              scope="col" title="Location"
              aria-label="Location"
            >Location</th>
						<th 
              scope="col"
              title="Full time"
              aria-label="Full time"
            >Full time</th>
						<th 
              scope="col"
              title="Part time"
              aria-label="Part time"
            >Part time</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              scope="row"
              title="Joondalup"
              aria-label="Joondalup"
            >
              Joondalup
            </th>
            <td>
              <i
                v-if="course.studyLocations[0].available == 'Y' && course.studyMode[0].fullTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>
            <td>
              <i
                v-if="course.studyLocations[0].available == 'Y' && course.studyMode[0].partTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>
          </tr>
          <tr>
            <th
              scope="row"
              title="Mount Lawley"
              aria-label="Mount Lawley"
            >
              Mount Lawley
            </th>
            <td>
              <i
                v-if="course.studyLocations[1].available == 'Y' && course.studyMode[0].fullTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>
            <td>
              <i
                v-if="course.studyLocations[1].available == 'Y' && course.studyMode[0].fullTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>
          </tr>
          <tr>
            <th
              scope="row"
              title="South West"
              aria-label="South West"
            >
              South West
            </th>
            <td>
              <i
                v-if="course.studyLocations[2].available == 'Y' && course.studyMode[0].fullTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>
            <td>
              <i
                v-if="course.studyLocations[2].available == 'Y' && course.studyMode[0].fullTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>

          </tr>
          <tr>
            <th
              scope="row"
              title="Online"
              aria-label="Online"
            >
              Online
            </th>
            <td>
              <i
                v-if="course.studyLocations[3].available == 'Y' && course.studyMode[0].fullTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>

            <td>
              <i
                v-if="course.studyLocations[3].available == 'Y' && course.studyMode[0].fullTime == 'Y'"
                class="fa-sharp fa-solid fa-circle"
                title="Available"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Course',
  props: {
    course: {
      type: Object,
      required: false,
      default: function () { return {} }
    }
  },
  computed: { // append class based on studyarea
    className: function () {
      let sa = ''

      switch (this.course.studyAreas[0]) {
        case 'Arts & Humanities':
          sa = 'arts_human'
          break
        case 'Business & Law':
          sa = 'bus_law'
          break
        case 'Engineering & Technology':
          sa = 'eng_tech'
          break
        case 'Medical & Health Sciences':
          sa = 'med_health'
          break
        case 'Nursing & Midwifery':
          sa = 'nurs_midw'
          break
        case 'Science':
          sa = 'science'
          break
        case 'Teacher Education':
          sa = 'teachered'
          break
        case 'Western Australian Academy of Performing Arts':
          sa = 'waapa'
          break
      }

      return 'card-' + sa
    }
  }
}

</script>

<style lang="css">

</style>
